export const selectCustomersList = (state) => state.salesReturn.customersList;
export const selectVouchersList = (state) => state.salesReturn.salesVouchersList;
export const selectSalesReturnVoucher = (state) => state.salesReturn.salesReturnVoucher;
export const selectSalesReturnSuccess = (state) => state.salesReturn.salesReturnSuccess;
export const selectSelectedVoucherDetails = (state) => state.salesReturn.selectedVoucherDetails;
export const selectSalesReturnLoading = (state) => state.salesReturn.loading;
export const selectSalesReturnError = (state) => state.salesReturn.error;

// New account selectors
export const selectSalesReturnAccounts = (state) => state.salesReturn.salesReturnAccounts;
export const selectTaxAccounts = (state) => state.salesReturn.taxAccounts;
export const selectDiscountAccounts = (state) => state.salesReturn.discountAccounts;
export const selectTransportAccounts = (state) => state.salesReturn.transportAccounts;

// Serial modal state
export const selectSelectedSerials = (state) => state.salesReturn.selectedSerials;

export const selectFormData = (state) => state.salesReturn.formData;
export const selectFormCustomer = (state) => state.salesReturn.formData.customer;
export const selectFormOrderId = (state) => state.salesReturn.formData.orderId;
export const selectFormItemsList = (state) => state.salesReturn.formData.itemsList;
export const selectFormFooterValues = (state) => state.salesReturn.formData.footerValues;
export const selectFormSelectedSalesReturnAcc = (state) => state.salesReturn.formData.selectedSalesReturnAcc;
export const selectFormTaxMode = (state) => state.salesReturn.formData.taxMode;
export const selectFormTags = (state) => state.salesReturn.formData.tags;
export const selectFormSelectedTag = (state) => state.salesReturn.formData.selectedTag;
export const selectFormSelectedSaleInvoice = (state) => state.salesReturn.formData.selectedSaleInvoice;
